import {
  bannerHeight,
  bookImages,
  footerHeight,
  getBookList,
} from "../../shared/SharedFunctions";
import blankBookImage from "../../Images/BlankBook-min.png";
import { BookInfo } from "../../shared/models/BookInfo";
import { Box, Card, CardContent, Typography } from "@mui/material";
import GA4React from "ga-4-react";
import IntroducingSeamore from "../../Images/IntroducingSeamore-min.jpg";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../../shared/windowDimensions";

import styles from "./books.module.scss";

type BooksProps = {
  ga4react: GA4React;
  isMobileDevice: boolean;
};

const Books = ({ ga4react, isMobileDevice }: BooksProps) => {
  const [booksList, setBooksList] = useState([] as BookInfo[]);
  const navigate = useNavigate();
  const [pageContentHeight, setPageContentHeight] = useState("");
  const { screenHeight, screenWidth } = useWindowDimensions();

  useEffect(() => {
    setBooksList(getBookList());
  }, []);

  useEffect(() => {
    setPageContentHeight(
      `calc(${screenHeight}px - 31.5px - ${footerHeight} - ${bannerHeight} - ${footerHeight})`
    );
  }, [screenHeight]);

  return (
    <Box
      bgcolor="#CCCCCC"
      className={styles.pageContent}
      style={{
        //flexDirection: isMobileDevice ? "column" : "row",
        flexWrap: isMobileDevice ? "wrap" : "nowrap",
        height: pageContentHeight,
        justifyContent: "center",
        margin: "0 10px 10px 10px",
        padding: "10px 0",
      }}
    >
      <Box
        bgcolor="#CCCCCC"
        className={styles.bookList}
        sx={{
          justifyContent: "center",
          "&::-webkit-scrollbar": {
            width: "15px",
          },
          order: isMobileDevice ? 1 : 0,
          "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#666666",
            borderRadius: 2,
          },
        }}
      >
        {booksList.map((book) => (
          <Card
            key={book.Id}
            className={styles.cards}
            sx={{
              backgroundColor: "#7292c5",
              border: "1px solid #B3B3B3",
              borderRadius: "12px",
              height: "210px",
              margin: "5px 15px 10px 15px",
            }}
          >
            <CardContent
              onClick={() => {
                ga4react.event(
                  `Book Clicked: ${book.Title}`,
                  book.Title,
                  "Click",
                  false
                );
                navigate(`/book/:${book.Id}`);
              }}
              sx={{ display: "flex" }}
            >
              <Box className={styles.card}>
                <Box className={styles.bookCoverWrapper}>
                  <img
                    className={styles.bookBase}
                    src={blankBookImage}
                    alt="Blank book"
                  />
                  <img
                    className={styles.bookCover}
                    src={bookImages[book.Id]}
                    alt={book.Title}
                  />
                </Box>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>
      <Box
        bgcolor="#676767"
        className={styles.rightColumn}
        display="flex"
        flexDirection="column"
        margin="0 10px"
        sx={{
          order: isMobileDevice ? 0 : 1,
        }}
        width="335px"
      >
        <Box bgcolor="#676767" height="335px" margin="0 0 10px 0">
          <video
            autoPlay
            controls
            height="315px"
            loop
            muted
            poster={IntroducingSeamore}
            style={{ margin: "10px" }}
            width="315px"
          >
            <source
              src="https://jollyjourneypublishing.com/BookImages/AboutSeamore.mp4"
              type="video/mp4"
            />
            <p>
              Your browser does not support the video tag. Please click the
              following link to download the video.
            </p>
            <p>
              <a href="/images/AboutSeamore.mp4">AboutSeamore.mp4 download</a>
            </p>
          </video>
        </Box>
        <Typography
          color="white"
          fontSize="20px"
          margin="10px"
          textAlign="center"
        >
          Check out the books in the 'Seamore Adventure' series!
        </Typography>
      </Box>
    </Box>
  );
};

export default Books;
